module.exports = __webpack_public_path__ + "static/media/empty-nfg.99b0c108.svg";